import React from "react";
import { ImgBg } from "../ForgotPassword.styled";
import imgBg from "../../../Assets/bg.png";

export const BackgroundLogin = () => {
  return (
    <ImgBg>
      <img src={imgBg} alt="rv-logotipo" />
    </ImgBg>
  );
};
